import { useDebugValue, useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import styles from "./Connections.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import { BsCheckCircleFill, BsExclamation } from "react-icons/bs";
import { FaCircleExclamation as ExclamationIcon } from "react-icons/fa6";
import { VscUnlock } from "react-icons/vsc";
import { CgRemove } from "react-icons/cg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthMethods, ConnectionHubErrorTypes, IIntegrationPartner, IPWorkspace, IpNames, JobType, UserRole, rpaAuthTypes } from "../../interfaces/interfaces";
import { getLocalUser, getTemporaryUnavailableIps } from "../../components/functions/utilities";
import Integrations from "../../components/common/Integrations/Integration";
import { useAppDispatch, useAppSelector } from "../../redux/reduxHooks";
import { IpRestS } from "../../rest/ipRest-service";
import { RiArrowRightSLine } from "react-icons/ri";
import IpScreen from "./IpScreen/IpScreen";
import { AiFillInfoCircle } from "react-icons/ai";
import CustomerSelect from "./CustomerSelect/CustomerSelect";
import {
  addConnections,
  fetchCurrentConnections,
} from "../../redux/connections/connSlice";
import DisconnectScreen, { showDisconnectionSplit } from "./DisconnectScreen/DisconnectScreen";
import { RestS } from "../../rest/rest-service";
import { BiLockAlt } from "react-icons/bi";
import {
  deleteAccessTokens,
  fetchAccessTokens,
} from "../../redux/accessTokens/accessTokens";
import CircularLoader from "../../components/common/CircularLoader/CircularLoader";
import { clearCrendentialVerificationDetails } from "../../redux/credentialVerification/credentialVerification";
import { TermsAndConditions } from "./Tnc/Tnc";
import { HiChevronLeft } from "react-icons/hi";
import MeritoButton from "../../components/common/MeritoButtons/MeritoButtons";
import { MdKeyboardBackspace } from "react-icons/md";
import EmailOtpHome from "./EmailOtp/EmailOtpHome";
import ConnectionValidation from "./ConnectionValidation/ConnectionValidation";
import ConnectionResults from "./ConnectionValidation/ConnectionResults";
import ConnectionWarning from "./ConnectionWarning/ConnectionWarning";
import { accountSelectIps, directConnectIps } from "./utils/connection.util";
import { MdError as ErrorIcon } from 'react-icons/md'
import { RiLockFill as LockIcon } from 'react-icons/ri'
import { track } from "../../config/amplitude";

type Props = {
  toggle: () => void;
  visible: boolean;
  clearParams: () => void;
  connectedState: any;
  onDisconnectRefresh?: () => void;
};

const selectAccountRpaIps = new Set([IpNames.swiggyInstamart]);

const Connections = ({
  toggle,
  visible,
  clearParams,
  connectedState = {
    takeState: false,
  },
  onDisconnectRefresh = () => { }
}: Props) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [workspaces, setWorkspaces] = useState([]);
  const [ips, setIps] = useState<any>([]);
  const [step, setStep] = useState(1);
  const [customers, setCustomers] = useState<any>([]);
  const [success, setSuccess] = useState(false);

  const currentUser = getLocalUser();
  const isAgency = currentUser?.role == "Agency";

  // const [allConnectedAccounts, setAllConnectedAccounts] = useState([])
  const allConnectedAccounts = useAppSelector(
    (state) => state.accessTokens,
  ).accessTokens;
  // Step 1: All Integration Partner Visible
  // Step 2: Google Ads and Google Analytics Login Screen
  // Step 3: Customer Account Selection
  // Step 4: Success/Failure
  // Step 5: Disconnect Screen
  // Step 6: Disconnect Confirmation Screen
  // Step 7: Disconnected Success Screen
  // Step 8: Terms and Condition Screen. We consider the Step 8 will only be opened from Step 2
  // Step 9: Loading Screen
  const [ip, setIp] = useState(null);
  const [selectedIp, setSelectedIp] = useState<any>({});
  const [selectedCustomers, setSelectedCustomers] = useState<any>({});
  const disonnectRef = useRef(null);
  const { connectionStatus } = useAppSelector((state) => state.connections);
  const [isUpdated, setIsUpdated] = useState(false);
  const [expiredAccounts, setExpiredAccounts] = useState([]);
  const [invalidCreds, setInvalidCreds] = useState(false)
  const credentialVerification = useAppSelector(state => state.credentialVerification);
  const [errorType, setErrorType] = useState<ConnectionHubErrorTypes>(null);

  // console.log('connection state', connectedState, "visible", visible)

  const { currentClient } = useAppSelector((state) => state.agencyConfig);


  useEffect(() => {
    console.log('HIT')
    if (!credentialVerification.integrationPartner?.id) return;
    IpRestS.getIpByName(credentialVerification.integrationPartner?.name)
      .then((resIp) => {
        console.log('Handling the websocket response', step, credentialVerification)
        if (!visible || step == 9) {
          setSelectedIp(resIp)
          setIp(resIp as any)
          if (!credentialVerification.isCredentialValid) {
            if (credentialVerification.credentialError == 'Invalid Credentials' && resIp?.authMethod == AuthMethods.password) {
              setStep(2)
            } else if (!credentialVerification.isConnectionHubOpen) {
              setStep(2)
              dispatch(clearCrendentialVerificationDetails())
            } else {
              setSuccess(false)
              setErrorType(credentialVerification.credentialError as ConnectionHubErrorTypes)
              setStep(4)
              dispatch(clearCrendentialVerificationDetails())
            }
          } else if (credentialVerification.isConnectionHubOpen) {
            // Success
            if (selectAccountRpaIps.has(credentialVerification.integrationPartner?.name)) {
              if (credentialVerification?.brands?.length) {
                // const formattedBrands = credentialVerification?.brands.map(brand => {
                //   return {
                //     id: brand?.id,
                //     name: brand?.name,
                //     accountId: credentialVerification?.accountId,
                //     parentName: "Accounts",
                //     selected: false
                //   }
                // });
                console.log('formattedBrands', credentialVerification?.brands)
                setCustomers(credentialVerification?.brands)
                setStep(3)
              }
            } else {
              setSuccess(true)
              setStep(4)
              dispatch(clearCrendentialVerificationDetails())
            }
          } else {
            dispatch(fetchCurrentConnections({
              companyId: isAgency ? currentClient?.id : undefined
            }));
            dispatch(fetchAccessTokens(isAgency ? `${currentClient?.id}` : null));
          }
        }
      })
  }, [credentialVerification.integrationPartner])

  useEffect(() => {
    fetchExpiredAccounts();
  }, [])

  const fetchExpiredAccounts = async () => {
    try {
      console.log('FETCHING EXPIRED ACCOUNTS')
      const res: any = await RestS.getExpiredAccounts();
      setExpiredAccounts(res);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (visible != undefined) {
      console.log('setting connection hub from visible', visible)
      localStorage.setItem('isConnectionHubOpen', visible.toString())
    }
  }, [visible])

  useEffect(() => {
    dispatch(fetchCurrentConnections({
      companyId: isAgency ? currentClient?.id : null,
    }));
    // RestS.getUserAccessTokensByUserId()
    //     .then(res => {
    //         setAllConnectedAccounts(res)
    //     })
    //     .catch(err => {
    //         console.log(err)
    //     })
    dispatch(fetchAccessTokens(isAgency ? `${currentClient?.id}` : null));
  }, [step, currentClient]);

  const getDetailsFromState = () => {
    // console.log('connectionState', connectedState)
    console.log('running get details from state', connectedState)

    if (connectedState?.directConnect) {
      let user = getLocalUser();
      user = {
        ...user,
        companyId: isAgency ? currentClient?.id : user?.companyId,
      };
      const fullIp = (ips as any[]).find((i) => i.companyName === connectedState.ip?.companyName) || connectedState.ip;
      setSelectedIp(fullIp);
      if (isAgency && directConnectIps.has(fullIp?.companyName)) {
        setIp(fullIp);
        setStep(11);
        clearParams();
        return;
      }
      Integrations(
        fullIp.companyName,
        fullIp._id,
        user,
        fullIp,
        1,
        setStep,
        setIp,
      );
      clearParams();
      return;
    }

    setSuccess(connectedState.success);
    setStep(connectedState.step);
    if (connectedState.customers && connectedState.success) {
      setCustomers(connectedState.customers);
      setStep(3);
    }
    setSelectedIp(connectedState.ip);
    if (connectedState?.showIpScreen) {
      setStep(5)
    }
    if (connectedState?.loginScreen) {
      setIp(connectedState.ip)
      setStep(2)
    }
    clearParams();
  };

  const getDetailsFromParam = () => {
    setSuccess(!!searchParams.get("success"));
    console.log('searchParamas inside connectionHub', searchParams)
    if (searchParams.get("step")) {
      setStep(Number(searchParams.get("step")));
    }
    if (searchParams.get("customers")) {
      setCustomers(JSON.parse(searchParams.get("customers")));
      setStep(3);
    }
    if (searchParams.get("ip")) {
      setSelectedIp(JSON.parse(searchParams.get("ip")));
    }
    if (searchParams.get("isUpdated")) {
      setIsUpdated(true);
    }

    console.log(isUpdated, 'isUpdated', searchParams.get("isUpdated"))

    clearParams();
  };

  useEffect(() => {
    console.log("connectedState", connectedState);
    if (connectedState?.takeState) {
      getDetailsFromState();
    } else {
      getDetailsFromParam();
    }
  }, [connectedState?.takeState]);

  // useEffect(() => {
  //   if ()
  // }, [])



  const handleToggle = () => {
    toggle();
    setStep(1);
    // setTimeout(() => {
    //   setStep(1);
    // }, 1000);
  };

  useEffect(() => {
    IpRestS.getAllActiveWorkspaces()
      .then((res) => {
        setWorkspaces(res);
        // const addedIps = new Set();
        // let ipTemp = [];
        // for (var ws of res) {
        //   if (
        //     !(
        //       addedIps.has(ws?.integrationPartner?._id) ||
        //       ws?.integrationPartner?.combined
        //     )
        //   ) {
        //     addedIps.add(ws?.integrationPartner?._id);
        //     ipTemp.push(ws?.integrationPartner);
        //   } else {
        //     const consolidatedIps = ws?.integrationPartner?.combined
        //       ? ws?.integrationPartner?.mandatoryIp
        //         ?.concat(ws?.integrationPartner?.optionalIp)
        //         ?.concat(ws?.integrationPartner?.nonMandatoryIp)
        //       : [];
        //     for (var i of consolidatedIps) {
        //       if (!addedIps.has(i._id)) {
        //         addedIps.add(i?._id);
        //         ipTemp.push(i);
        //       }
        //     }
        //   }
        // }
        // setIps(ipTemp);
      })
    IpRestS.getAllIpByStatus()
      .then(res => {
        console.log('ALLIPS', res.data)
        setIps(res.data);
      })
      .catch(err => {
        console.log(`Error in GetAllIpByStatus: ${err}`)
      })
      .catch((err) => console.log(err));
  }, []);

  const getSubHeader = () => {
    const accountsNum = allConnectedAccounts.filter(
      (acc) => acc.integrationPartner == selectedIp._id,
    ).length;
    const expiredAccIp = expiredAccounts?.filter(acc => acc.integrationPartner == selectedIp?._id)

    switch (step) {
      case 1:
        return (
          <>
            {/* <p>Integrations</p> */}
            <hr></hr>
          </>
        );
      case 2:
        return <></>;
      case 5:
        return (
          <>
            <div className={styles.ipContSeperate}>
              <div className={styles.content}>
                <img className={styles.logo} src={selectedIp.logo} />
                <div>
                  <h3>{selectedIp.companyName}</h3>
                  {/* {!accountsNum ? (
                    <p>No Accounts added</p>
                  ) : (
                    <p className={styles.green}>
                      {accountsNum} Account connected
                    </p>
                  )} */}
                </div>
              </div>
              <div
                className={styles.connect}
                onClick={() => {
                  setIp(selectedIp);
                  let user = getLocalUser();

                  if (isAgency && directConnectIps.has(selectedIp?.companyName)) {
                    setStep(11);
                    return;
                  }
                  user = {
                    ...user,
                    companyId: isAgency ? currentClient?.id : user?.companyId,
                  }
                  Integrations(
                    selectedIp.companyName,
                    selectedIp._id,
                    user,
                    selectedIp,
                    step,
                    setStep,
                    setIp,
                  );
                }}
              >
                <BiLockAlt />
                Connect New Account
              </div>
            </div>
            {/* {!selectedIp?.isSalesChannel && showDisconnectionSplit?.has(connectedState?.fromScreen) && expiredAccIp?.length ? null : <hr></hr>} */}
          </>
        );
      case 8:
        return (
          <div className={styles.tncHeader}>
            <MeritoButton type="tertiary" size="md" onlyIcon={true} onClick={() => {
              setStep(2)  // Considering the terms and condition will only be opened from Step 2
            }}>
              <MdKeyboardBackspace />
            </MeritoButton>
            <h1>Terms & Conditions</h1>
          </div>
        )
      default:
        <></>;
    }
  };

  const shouldConnect = () => {
    // let flag = false;
    // console.log('selectedCustomers', selectedCustomers)
    // Object.values(selectedCustomers).forEach((cust: boolean) => {
    //   flag = flag || cust;
    // });
    // console.log('flag', flag)
    // return flag;
    for (const key in selectedCustomers) {
      if (selectedCustomers.hasOwnProperty(key)) {
        const property = selectedCustomers[key];
        if (property && property.selected) {
          return true; // if any selected is true then return true
        }
      }

    }
    return false;
  };

  const connectAccounts = async () => {
    const accDetails = Object.keys(selectedCustomers)
      .map((id) => {
        if (selectedCustomers[id]?.selected) {
          return selectedCustomers[id]?.details;
        }
      })
      .filter((cust) => cust != undefined);

    console.log('accDetails', accDetails)

    dispatch(addConnections(selectedIp["_id"]));

    let connectionSuccess = false;

    switch (selectedIp.companyName) {
      case IpNames.googleAnalytics: {
        const response = await IpRestS.addGAIntegrationCustomerDetails({
          ipId: selectedIp["_id"],
          accDetails: accDetails,
          agencyClientId: isAgency ? currentClient?.id : null
        });
        startPullingData(selectedIp);
        dispatch(fetchCurrentConnections({
          companyId: isAgency ? currentClient?.id : null,
        }));
        connectionSuccess = !!response?.success;
        setSuccess(response?.success);
        setStep(4);
        break;
      }
      case IpNames.googleAds: {
        const response = await IpRestS.addIntegrationCustomerDetails({
          ipId: selectedIp["_id"],
          accDetails: accDetails,
          agencyClientId: isAgency ? currentClient?.id : null
        });
        startPullingData(selectedIp);
        dispatch(fetchCurrentConnections({
          companyId: isAgency ? currentClient?.id : null,
        }));
        connectionSuccess = !!response?.success;
        setSuccess(response?.success);
        setStep(4);
        break;
      }
      case IpNames.metaAds: {
        const response = await IpRestS.addFacebookAdAccount({
          ipId: selectedIp["_id"],
          accDetails: accDetails,
          agencyClientId: isAgency ? currentClient?.id : null
        });
        startPullingData(selectedIp);
        dispatch(fetchCurrentConnections({
          companyId: isAgency ? currentClient?.id : null,
        }));
        connectionSuccess = !!response?.success;
        setSuccess(response?.success);
        setStep(4);
        break;
      }
      case IpNames.amazonAds: {
        const response = await IpRestS.addAmazonAdAccount({
          ipId: selectedIp["_id"],
          accDetails: accDetails,
          agencyClientId: isAgency ? currentClient?.id : null
        });
        startPullingData(selectedIp);
        dispatch(fetchCurrentConnections({
          companyId: isAgency ? currentClient?.id : null,
        }));
        connectionSuccess = !!response?.success;
        setSuccess(response?.success);
        setStep(4);
        break;
      }
      case IpNames.flipkartAds: {
        const response = await IpRestS.addAmazonAdAccount({
          ipId: selectedIp["_id"],
          accDetails: accDetails,
          agencyClientId: isAgency ? currentClient?.id : null
        });
        startPullingData(selectedIp);
        dispatch(fetchCurrentConnections({
          companyId: isAgency ? currentClient?.id : null,
        }));
        connectionSuccess = !!response?.success;
        setSuccess(response?.success);
        setStep(4);
        break;
      }
      case IpNames.swiggyInstamart: {
        const response = await IpRestS.addRpaBrands({
          integrationPartner: selectedIp,
          accDetails: accDetails,
          agencyClientId: isAgency ? currentClient?.id : null
        });
        connectionSuccess = !!response?.success;
        setSuccess(response?.success);
        setStep(4);
        break;
      }
      default: {
        break;
      }
    }

    track("integration_connected", {
      integration_name: selectedIp.companyName,
      success: connectionSuccess,
      accounts_count: accDetails.length,
    });
  };

  const startPullingData = async (integrationPartner) => {
    try {
      const pullData = await RestS.pullData({
        integrationPartner: integrationPartner,
        extraParams: {
          agencyClientId: isAgency ? currentClient?.id : null,
        }
      });
      RestS.refreshNow({
        ip: integrationPartner,
        jobType: JobType.refreshNow,
        agencyClientId: isAgency ? currentClient?.id : null
      });
    } catch (error) {
      console.log(error);
    }
  };

  const actionBtns = () => {
    switch (step) {
      case 1: {
        return (
          <div className={`${styles.actionBtn} ${styles.flexEnd}`}>
            <div onClick={() => handleToggle()}>Done</div>
          </div>
        );
      }
      case 4:
        if (success) {
          if ([IpNames.blinkitB2b, IpNames.nykaa, IpNames.myntra, IpNames.blinkitMarketplace].includes(selectedIp?.companyName)) return <></>;
          return (
            <div className={`${styles.actionBtn} ${styles.flexEnd}`}>
              <div
                onClick={() => {
                  setStep(1);
                  // Refresh Now API Call
                  // RestS.refreshNow(selectedIp, JobType.refreshNow)
                }}
              >
                Connect another Account
              </div>
            </div>
          );
        } else {
          return (
            <>
              {selectedIp?.authMethod == AuthMethods.email_otp || selectedIp?.authMethod == AuthMethods.email_otp_password ? null : <div className={styles.actionBtn}>
                <div onClick={() => setStep(1)}>Try Again</div>
              </div>}
            </>
          );
        }
      case 3:
        if (!customers?.length) {
          return (
            <div className={`${styles.actionBtn}`}>
              <div onClick={() => setStep(1)}>Back</div>
            </div>
          )
        }
        return (
          <div className={styles.actionBtn}>
            <div onClick={() => setStep(1)}>Back</div>
            <div
              className={shouldConnect() ? "" : styles.disable}
              onClick={() => {
                if (currentUser?.role == UserRole.Agency) {
                  setStep(11)
                } else {
                  connectAccounts();
                }
              }}
            >
              Connect Account
            </div>
          </div>
        );
      case 6:
        return (
          <div className={styles.actionBtn}>
            <div onClick={() => setStep(5)}>Back</div>
            <div
              onClick={() => {
                if (disonnectRef.current) {
                  disonnectRef.current.disConnectAcc();
                  // Refresh Now API Call
                  // RestS.refreshNow(selectedIp, JobType.refreshNow)
                }
                track("integration_disconnected", {
                  integration_name: selectedIp?.companyName,
                });
                setStep(7);
              }}
            >
              Disconnect Account
            </div>
          </div>
        );
      case 7:
        return (
          <div className={styles.actionBtn}>
            <div onClick={() => setStep(1)}>Back</div>
          </div>
        );
      case 8:
        return (
          <div className={styles.actionBtn}>
            <div onClick={() => {
              setStep(2)  // Considering the terms and condition will only be opened from Step 2
            }}>Back</div>
          </div>
        );
      case 9:
        return (<div></div>)
      case 11:
        return (
          <div className={styles.bottomBtnContainer}>
            <MeritoButton
              type="secondary-2"
              size="lg"
              btnText="Back"
              isRounded={true}
              onClick={() => {
                const currentIp = ip || selectedIp;
                if (directConnectIps.has(currentIp?.companyName)) {
                  setStep(1)
                }
                if (rpaAuthTypes.has(currentIp?.authMethod)) {
                  setStep(1)
                }
                if (accountSelectIps.has(currentIp?.companyName)) {
                  setStep(3)
                }
              }}
            />
            <MeritoButton
              type="primary-1"
              size="lg"
              btnText="Connect"
              isRounded={true}
              onClick={() => {
                const currentIp = ip || selectedIp;
                if (directConnectIps.has(currentIp?.companyName)) {
                  let user = getLocalUser();
                  user = {
                    ...user,
                    companyId: isAgency ? currentClient?.id : user?.companyId,
                  }
                  Integrations(
                    currentIp.companyName,
                    currentIp._id,
                    user,
                    currentIp,
                    step,
                    setStep,
                    setIp,
                  );
                } else if (rpaAuthTypes.has(currentIp?.authMethod)) {
                  setStep(10)
                } else {
                  connectAccounts();
                }
              }}
            />
          </div>
        )
      default:
        return (
          <div className={styles.actionBtn}>
            <div onClick={() => {
              setStep(1)
            }}>Back</div>
          </div>
        );
    }
  };

  // const flipkartExpiredAccLength = (ip) => {
  //   if (ip?.name != IpNames.flipkartSeller) {
  //     return 0
  //   } else {
  //     const acc = expiredAccounts?.filter(acc => acc.integrationPartner == ip?._id)
  //     return acc.length
  //   }
  // }

  const removeCompanyNameSteps = new Set([11, 2]);

  const unavailableIps = getTemporaryUnavailableIps();

  return (
    <Modal
      toggle={handleToggle}
      isOpen={visible}
      centered
      size="lg"
      modalClassName={styles.confirmBox}
      wrapClassName={styles.confirmBox}
      contentClassName={styles.contentBox}
      backdrop={"static"}
    >
      <ModalBody className={`${styles.body} ${styles[`step${step}`]}`}>
        {step == 10 ? (
          <EmailOtpHome
            handleModalToggle={handleToggle}
            ip={ip}
            setStep={setStep}
            setIp={setIp}
            setSelectedIp={setSelectedIp}
            setSuccess={setSuccess}
          />
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.mainHeader}>
                <div className={styles.leftContainer}>
                  {currentClient?.name && isAgency && !removeCompanyNameSteps.has(step) ?
                    <div className={styles.clientTitle}>
                      {currentClient.name}
                    </div> : null}
                  <div className={styles.popupTitle}>{[1, 3, 5].includes(step) ? "Connect Accounts" : ""}</div>

                </div>
                <div className={styles.rightContainer}>
                  {![8].includes(step) ? (
                    <div
                      className={styles.closeButton}
                      onClick={() => handleToggle()}
                    >
                      <AiOutlineClose />
                    </div>
                  ) : null}
                </div>
              </div>
              {getSubHeader()}
            </div>

            <div
              className={`${styles.connectionBody} ${step == 4 ? styles.fullHeight : ""} ${step == 3 ? styles.minusMargin : ""
                }`}
            >
              {step == 1
                ? ips?.map((ip) => {
                  const auth =
                    connectionStatus?.includes(ip._id)
                      ? connectionStatus?.includes(ip._id)
                      : false
                  const num = allConnectedAccounts.filter(
                    (acc) => acc.integrationPartner == ip._id
                  ).length;
                  return (
                    <div
                      className={`${styles.ip} ${unavailableIps?.has(ip?.companyName) ? styles.ipDisable : auth ? styles.pointer : ""}`}
                      key={ip?._id}
                      onClick={() => {
                        if (unavailableIps?.has(ip?.companyName)) {
                          return;
                        }
                        if (auth) {
                          setSelectedIp(ip);
                          setStep(5);
                        }
                      }}
                    >
                      <div className={styles.ipCont}>
                        <img className={styles.logo} src={ip.logo} />
                        <div>
                          <h3>{ip.companyName}</h3>
                          {unavailableIps?.has(ip?.companyName) ?
                            <div className={styles.unavailableIpRootContainer}>
                              <div className={styles.iconContainer}><ErrorIcon /></div>
                              <div className={styles.unavailableIpText}>Due to an AWS outage, {ip.companyName} is temporarily unavailable for connection.</div>
                            </div>
                            : !num ? (
                              <p>No Accounts added</p>
                            ) : (
                              <p className={styles.green}>
                                {num} Account connected
                              </p>
                            )}
                        </div>
                      </div>
                      <div>
                        <div className={styles.ipAuth}>
                          {unavailableIps?.has(ip?.companyName) ?
                            <div className={styles.tempUnavailableRootContainer}>
                              <div className={styles.iconContainer}>
                                <LockIcon />
                              </div>
                            </div>
                            :
                            auth ? (
                              <div className={styles.textGrey}>
                                <RiArrowRightSLine />
                              </div>
                            ) : (
                              <div
                                className={styles.Authenticate}
                                onClick={() => {
                                  // console.log(
                                  //   "connect button clicked"
                                  // );
                                  track("connection_attempted", {
                                    integration_name: ip.companyName,
                                  });
                                  let user = getLocalUser();
                                  user = {
                                    ...user,
                                    companyId: isAgency ? currentClient?.id : user?.companyId,
                                  };
                                  if (currentUser?.role == UserRole.Agency && directConnectIps.has(ip.companyName)) {
                                    setStep(11);
                                    setIp(ip);
                                    return;
                                  }
                                  Integrations(
                                    ip.companyName,
                                    ip._id,
                                    user,
                                    ip,
                                    step,
                                    setStep,
                                    setIp,
                                    false
                                  );
                                }}
                              >
                                <VscUnlock />
                                <p>Connect</p>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  );
                })
                : null}
              {step == 2 ? <IpScreen ip={ip as any} setStep={setStep} setSelectedIp={setSelectedIp} setSuccess={setSuccess} /> : null}
              {step == 3 && selectedIp ? (
                <CustomerSelect
                  customers={customers}
                  ip={selectedIp}
                  selectedCustomers={selectedCustomers}
                  setSelectedCustomers={setSelectedCustomers}
                  allConnectedAccounts={allConnectedAccounts}
                />
              ) : null}
              {step == 4 && selectedIp && selectedIp.companyName ? (
                <>
                  <ConnectionResults
                    selectedIp={selectedIp}
                    success={success}
                    setSuccess={setSuccess}
                    isUpdated={isUpdated}
                    setStep={setStep}
                    errorType={errorType}
                  />
                </>
              ) : null}
              {step == 5 || step == 6 || step == 7 ? (
                <>
                  <DisconnectScreen
                    ip={selectedIp}
                    accounts={allConnectedAccounts}
                    setAccounts={deleteAccessTokens}
                    setStep={setStep}
                    step={step}
                    disonnectRef={disonnectRef}
                    onDisconnectRefresh={onDisconnectRefresh}
                    setIp={setIp}
                    expiredAccounts={expiredAccounts}
                    fromScreen={connectedState?.fromScreen}
                    refreshExpiredAccounts={fetchExpiredAccounts}
                  />
                </>
              ) : null}
              {step == 8 ? <TermsAndConditions /> : null}
              {step == 9 ? <ConnectionValidation ip={ip} /> : null}

              {step == 11 ?
                <ConnectionWarning
                  ip={ip || selectedIp}
                  selectedCustomers={selectedCustomers}
                />
                : null}
            </div>

            {actionBtns()}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default Connections;
